import React, { Component } from "react";
import { NavMenu } from "./NavMenu";
import NavBar from "./navbar/NavBar";
import SideBar from "./sidebar/SideBar";
import { Route, Redirect, Switch } from "react-router";
import { withLocalize } from "react-localize-redux";
import { GetStudentName } from "../GeneralAPI";
import ReactGA from "react-ga";
import MyModal from "./MyModal";
import Axios from "axios";
import EmailMobileModal from "./EmailMobileModal";
import ProfileModal from "./ProfileModal";
class Layout extends Component {
  static displayName = Layout.name;
  fetchS = () => {
    if (this.props.ID !== "" && this.props.ID != "-1")
      GetStudentName(this.props.ID).then(data => {
        console.log(data);
        this.setState({ name: data });
      });
  };

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      feedback: "",
      OldPassword: "",
      NewPassword: "",
      ConfirmPassword: "",
      showContactModal: false,
      showProfileModal: false
    };
    this.fetchS();
  }
  componentDidUpdate(prevProps) {
    ReactGA.initialize("UA-51484481-8");
    let url = window.location.pathname + window.location.search;
    if (url.toLocaleLowerCase().includes("result")) {
      url = "/results";
    } else if (url.toLocaleLowerCase().includes("chatservice")) {
      url = "/chatservice";
    } else if (url.toLocaleLowerCase().includes("course")) {
      if (url.toLocaleLowerCase().includes("elearning"))
        url = "/course/elearning";
      else if (url.toLocaleLowerCase().includes("community"))
        url = "/course/community";
      else if (url.toLocaleLowerCase().includes("members"))
        url = "/course/members";
      else if (url.toLocaleLowerCase().includes("books")) url = "/course/books";
      else url = "/course/";
    }
    ReactGA.pageview(url);
    if (prevProps.isLogin === this.props.isLogin) {
    } else {
      this.fetchS();
    }
  }
  render() {
    return (
      <div
        id="page-container"
        class="fade page-sidebar-fixed page-header-fixed page-with-light-sidebar page-with-wide-sidebar "
      >
        <NavBar
          ID={this.props.ID}
          isLogin={this.props.isLogin}
          name={this.state.name}
          openContactModal={() => this.setState({ showContactModal: true })}
          openProfileModal={() => this.setState({ showProfileModal: true })}
        />
        <SideBar
          name={this.state.name}
          services={this.props.services}
          ID={this.props.ID}
          isLogin={this.props.isLogin}
        />
        <div id="content" class="content">
          {this.props.children}
        </div>
        <MyModal
          title="Feedback & Suggestions"
          actionButtonText="Submit Feedback"
          mID="feedback"
          actionButonClick={() => {
            Axios.post(
              "api/General/AddFeedback",
              {
                Feedback: this.state.feedback
              },
              {
                headers: {
                  "Content-Type": "application/json"
                }
              }
            );
            const $ = window.$;

            $("#feedbackModal").modal("hide");
          }}
        >
          <p>Your feedback and suggestions allow us to enhance our services.</p>
          <div class="form-group feedbackForm">
            <label for="feedback">Feedback &amp; Suggestions</label>
            <textarea
              class="form-control"
              id="feedbackTxt"
              rows="3"
              onChange={event =>
                this.setState({ feedback: event.target.value })
              }
              value={this.state.feedback}
              placeholder="Type you feedback here..."
            ></textarea>
          </div>
        </MyModal>
        <MyModal
          title="Change Password"
          actionButtonText="Change Password"
          mID="ChangePassword"
          actionButonClick={() => {
              if (this.state.NewPassword.trim() == '') {
                  alert('Please enter new password')
                  return;
              } else {
                  if (this.state.NewPassword.length >= 8)
                  var hasUpperCase = /[A-Z]/.test(this.state.NewPassword);
                  var hasLowerCase = /[a-z]/.test(this.state.NewPassword);
                  var hasNumbers = /\d/.test(this.state.NewPassword);
                  var hasNonalphas = /\W/.test(this.state.NewPassword);
                  var message = "Your password should contains: ";
                  if (hasUpperCase == 0) message += "at least one uppercase Letter, ";
                  if (hasLowerCase == 0) message += "at least one lowercase Letter, ";
                  if (hasNumbers == 0) message += "at least one digit, ";
                  if (hasNonalphas == 0) message += "at least one symbol ";
                  if (hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas < 3) {
                      alert(message);
                      return;
                  } else if (this.state.NewPassword.length < 8) {
                      alert("Password length should be greater than 8 letters");
                      return;
                  
                  } else {
                      if (this.state.NewPassword != this.state.ConfirmPassword) {
                          alert("You should confirm your new password.");
                          return;
                      }
                      Axios.post(
                          "api/Login/ChangePassword",
                          {
                              OldPassword: this.state.OldPassword,
                              NewPassword: this.state.NewPassword,
                              ConfirmPassword: this.state.ConfirmPassword
                          },
                          {
                              headers: {
                                  "Content-Type": "application/json"
                              }
                          }
                      );
                      const $ = window.$;

                      $("#ChangePasswordModal").modal("hide");
                  }

                  
              }


              
          }}
        >
          <div class="form-group ChangePasswordForm">
            <label for="oldPWD">Current Password</label>
            <input
              type="password"
              class="form-control"
              id="oldPWD"
              onChange={event =>
                this.setState({ OldPassword: event.target.value })
              }
              value={this.state.OldPassword}
              placeholder="Your Current Password"
            />
          </div>
          <hr />
          <div class="form-group ChangePasswordForm">
            <label for="newPwd1">New Password</label>
            <input
              type="password"
              class="form-control"
              id="newPwd1"
              onChange={event =>
                this.setState({ NewPassword: event.target.value })
              }
              value={this.state.NewPassword}
              placeholder="New Password"
            />
          </div>

          <div class="form-group ChangePasswordForm">
            <label for="newPwd2">Retype New Password</label>
            <input
              type="password"
              class="form-control"
              id="newPwd2"
              onChange={event =>
                this.setState({ ConfirmPassword: event.target.value })
              }
              value={this.state.ConfirmPassword}
              placeholder="Confirm New Password"
            />
          </div>
        </MyModal>
        {/* Change Contact Info Modal (Email & Mobile) */}
        <EmailMobileModal
          show={this.state.showContactModal}
          onClose={() => this.setState({ showContactModal: false })}
          onSuccess={() => this.setState({ showContactModal: false })}
        />
        <ProfileModal
          show={this.state.showProfileModal}
          onClose={() => this.setState({ showProfileModal: false })}
        />
      </div>
    );
  }
}
//  const LayoutRoute = ({ activeLanguage, component: Component, ...rest}) => {

//     return (
//       <Route {...rest} render={matchProps => (
//         <Layout>
//           {activeLanguage.code}
//           {'amr'}
//             <Component {...matchProps} />
//         </Layout>
//       )} />
//     )
//   };
//   export default withLocalize( LayoutRoute);

export default withLocalize(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout.js